import { jsx as _jsx } from "react/jsx-runtime";
import { FieldViewType } from "../viewType";
import MultiEnumFieldDetail from "./detail";
export default function MultiEnumFieldList(_a) {
    var fieldName = _a.fieldName, record = _a.record, moduleName = _a.moduleName;
    return (_jsx(MultiEnumFieldDetail, { fieldName: fieldName, record: record, viewType: FieldViewType.DETAIL, moduleName: moduleName }));
}
